/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AppPermissionsEnum } from './AppPermissionsEnum';
import {
    AppPermissionsEnumFromJSON,
    AppPermissionsEnumFromJSONTyped,
    AppPermissionsEnumToJSON,
} from './AppPermissionsEnum';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { RoleStateOfUse } from './RoleStateOfUse';
import {
    RoleStateOfUseFromJSON,
    RoleStateOfUseFromJSONTyped,
    RoleStateOfUseToJSON,
} from './RoleStateOfUse';
import type { RoleType } from './RoleType';
import {
    RoleTypeFromJSON,
    RoleTypeFromJSONTyped,
    RoleTypeToJSON,
} from './RoleType';

/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {RoleType}
     * @memberof RoleDto
     */
    type?: RoleType;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<AppPermissionsEnum>}
     * @memberof RoleDto
     */
    grantedPermissions?: Array<AppPermissionsEnum> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    permissionsUpdated?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    assignedUsersCount?: number;
    /**
     * 
     * @type {RoleStateOfUse}
     * @memberof RoleDto
     */
    state?: RoleStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    wasAssigned?: boolean;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof RoleDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RoleDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof RoleDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof RoleDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof RoleDto
     */
    lastModifierUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof RoleDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof RoleDto
     */
    editingUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    $type?: RoleDtoTypeEnum;
}


/**
 * @export
 */
export const RoleDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationRolesDtoRoleDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Roles.Dto.RoleDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RoleDtoTypeEnum = typeof RoleDtoTypeEnum[keyof typeof RoleDtoTypeEnum];


/**
 * Check if a given object implements the RoleDto interface.
 */
export function instanceOfRoleDto(value?: unknown): value is RoleDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RoleDtoTypeEnum)[0];
}

export function RoleDtoFromJSON(json: any): RoleDto {
    return RoleDtoFromJSONTyped(json, false);
}

export function RoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'deleterUserId': !exists(json, 'deleterUserId') ? undefined : json['deleterUserId'],
        'deletionTime': !exists(json, 'deletionTime') ? undefined : json['deletionTime'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'type': !exists(json, 'type') ? undefined : RoleTypeFromJSON(json['type']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'displayName': json['displayName'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'grantedPermissions': !exists(json, 'grantedPermissions') ? undefined : (json['grantedPermissions'] === null ? null : (json['grantedPermissions'] as Array<any>).map(AppPermissionsEnumFromJSON)),
        'permissionsUpdated': !exists(json, 'permissionsUpdated') ? undefined : json['permissionsUpdated'],
        'assignedUsersCount': !exists(json, 'assignedUsersCount') ? undefined : json['assignedUsersCount'],
        'state': !exists(json, 'state') ? undefined : RoleStateOfUseFromJSON(json['state']),
        'wasAssigned': !exists(json, 'wasAssigned') ? undefined : json['wasAssigned'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'creatorUser': !exists(json, 'creatorUser') ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : HistoryDtoUserFromJSON(json['lastModifierUser']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'editingUser': !exists(json, 'editingUser') ? undefined : HistoryDtoUserFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function RoleDtoToJSON(value?: RoleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'iuid': value.iuid,
        'type': RoleTypeToJSON(value.type),
        'name': value.name,
        'displayName': value.displayName,
        'description': value.description,
        'grantedPermissions': value.grantedPermissions === undefined ? undefined : (value.grantedPermissions === null ? null : (value.grantedPermissions as Array<any>).map(AppPermissionsEnumToJSON)),
        'permissionsUpdated': value.permissionsUpdated,
        'assignedUsersCount': value.assignedUsersCount,
        'state': RoleStateOfUseToJSON(value.state),
        'wasAssigned': value.wasAssigned,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value.isAvailable,
        'creatorUser': HistoryDtoUserToJSON(value.creatorUser),
        'lastModifierUser': HistoryDtoUserToJSON(value.lastModifierUser),
        'possibleActions': value.possibleActions === undefined ? undefined : (value.possibleActions === null ? null : (value.possibleActions as Array<any>).map(PossibleActionDtoToJSON)),
        'editingUser': HistoryDtoUserToJSON(value.editingUser),
        'editingTime': value.editingTime,
        '$type': value.$type,
    });
}

